export const featuresData = [
    {
      id: 1,
      src: "https://s3.amazonaws.com/img.mynetdiary.com/keto/cover-premium-keto-recipes@2x.jpg",
      title: "Premium Recipes",
      desc: "Hundreds of easy recipes, with great variety, carefully crafted for great taste by a team of Registered Dietitians.",
      link:"."
    },
    {
      id: 2,
      src: "https://s3.amazonaws.com/img.mynetdiary.com/images/cover-easy-tracking-premium@2x.png",
      title: "Easy Tracking",
      desc: "Massive food catalog, fastest barcode scanner, quickest food lookup making food tracking a breeze",
      link:"."
    },
    {
      id: 3,
      src: "https://s3.amazonaws.com/img.mynetdiary.com/images/cover-insights-and-guidance-keto@2x.png",
      title: "Insights and Guidance",
      desc: "Encouraging and supportive feedback, guiding you to your goal.",
      link:"."
    },
];